<template>
    <index-table
        ref="table"
        :cols="[
            {
                value: 'original_filename',
                label: 'File',
                sortable: true,
                searchable: true,
            },
            {
                value: 'description',
                label: 'Description',
                sortable: true,
                searchable: true,
            },
            {
                value: 'created_by',
                label: 'Uploaded By',
                sortable: false,
                searchable: false,
                display: 'name',
            },
            {
                value: 'created_at',
                label: 'Uploaded',
                sortable: true,
                searchable: false,
                filter: 'whenFromNow',
            },
        ]"
        :defaultSort="defaultSort"
        :defaultDir="defaultDir"
        :title="'Diagnostic Logs'"
        :options="options"
        :optionsComponent="optionsComponent"
        :model="'diagnostic-logs'"
        :disableMultiSelect="true"
        data-test-id="diagnostic-logs-table"
    >
        <template #create>
            <upload-diagnostic-log-button
                v-if="can('create diagnostic logs')"
                @uploaded="reload"
            />
        </template>
    </index-table>
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'
import UploadDiagnosticLogButton from '@/components/DiagnosticLogs/UploadDiagnosticLogButton.vue'
import SortDirections from '@/constants/sort-directions'
import Permissions from '@/mixins/permissions'

export default {
    components: {
        IndexTable,
        UploadDiagnosticLogButton,
    },

    mixins: [Permissions],

    data() {
        return {
            defaultSort: 'created_at',
            defaultDir: SortDirections.DESC,
            optionsComponent: 'DiagnosticLogActions',
        }
    },

    computed: {
        options() {
            const options = []

            if (this.can('delete diagnostic logs')) {
                options.push('deletable')
            }

            return options
        },
    },

    methods: {
        reload() {
            this.$refs.table.loadData()
        },
    },
}
</script>
